// src/components/ODFLogo.jsx
import React from 'react';

// Recreates the ODF TRADES logo: large serif ODF + small spaced TRADES + bull/bear icon.
//
// The logo is ALWAYS clickable and ALWAYS returns the user to the brand
// homepage at "/". Callers can pass their own onClick to override.
// stopPropagation is used so wrapper-onClick patterns (legacy) don't
// double-fire.
export default function ODFLogo({ size = 'sidebar', onClick }) {
  const handleClick = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    if (onClick) { onClick(); return; }
    // Default: navigate to brand home (single-page-app friendly)
    if (typeof window !== 'undefined') {
      if (window.location.pathname === '/') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        window.history.pushState(null, '', '/');
        window.dispatchEvent(new PopStateEvent('popstate'));
      }
    }
  };

  const btn = {
    background: 'none', border: 'none', padding: 0, margin: 0,
    cursor: 'pointer', display: 'inline-flex', alignItems: 'center',
    outline: 'none',
  };

  if (size === 'sidebar') {
    return (
      <button onClick={handleClick} aria-label="Return to ODFTrades home"
        style={{ ...btn, flexDirection: 'column', alignItems: 'flex-start', padding: '0 4px 28px' }}>
        <svg width="148" height="56" viewBox="0 0 148 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* ODF — large serif letters */}
          <text
            x="2" y="40"
            fontFamily="'Georgia', 'Times New Roman', serif"
            fontSize="46"
            fontWeight="400"
            fill="#f0f0f5"
            letterSpacing="-1"
          >ODF</text>
          {/* TRADES — small spaced caps */}
          <text
            x="4" y="53"
            fontFamily="'IBM Plex Sans', 'Arial', sans-serif"
            fontSize="9"
            fontWeight="400"
            fill="#8888a8"
            letterSpacing="4"
          >TRADES</text>
          {/* Bull icon (simplified) */}
          <g transform="translate(108, 38) scale(0.55)" fill="#00e5a0">
            <path d="M2 8 C2 4 5 1 9 2 L14 4 L18 2 C20 1 22 3 21 5 L19 8 L22 14 C23 16 21 18 19 17 L15 15 L9 17 C7 18 5 16 6 14 L8 8 L5 6 Z" opacity="0.9"/>
            {/* horns */}
            <path d="M7 3 L4 0 M13 3 L16 0" stroke="#00e5a0" strokeWidth="1.5" strokeLinecap="round"/>
          </g>
          {/* Bear icon (simplified) */}
          <g transform="translate(122, 40) scale(0.45)" fill="#ff4d6d">
            <path d="M3 6 C2 3 5 0 8 1 L12 2 L15 1 C18 0 20 3 19 6 L17 10 C18 12 17 15 15 14 L12 12 L8 14 C6 15 5 12 6 10 Z" opacity="0.9"/>
            {/* ears */}
            <circle cx="4" cy="2" r="2"/>
            <circle cx="15" cy="2" r="2"/>
          </g>
        </svg>
      </button>
    );
  }

  // Compact version for small spaces
  return (
    <button onClick={handleClick} aria-label="Return to ODFTrades home" style={btn}>
      <svg width="80" height="28" viewBox="0 0 80 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <text x="1" y="20" fontFamily="'Georgia', serif" fontSize="22" fontWeight="400" fill="#f0f0f5" letterSpacing="-0.5">ODF</text>
        <text x="2" y="27" fontFamily="'IBM Plex Sans', sans-serif" fontSize="6" fontWeight="400" fill="#8888a8" letterSpacing="3">TRADES</text>
      </svg>
    </button>
  );
}
